import(/* webpackMode: "eager" */ "/home/ubuntu/download_production/697c73333f594f00070ea6cc/restaurantbrand/src/app/not-found.tsx");
